import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/exportacao`

    const headers = {responseType: 'arraybuffer'}

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        download(queryParms = {}) {
            return repository.get(`${baseUrl}/download?${urlUtil.serialize(queryParms)}`, headers)
        },
        downloadArquivo(id) {
            return repository.get(`${baseUrl}/${id}/downloadArquivo`, headers)
        },
        getExportacoes(queryParms) {
            return repository.get(`${baseUrl}/exportacao?${urlUtil.serialize(queryParms)}`)
        },
        getArquivos(queryParms) {
            return repository.get(`${baseUrl}/arquivos?${urlUtil.serialize(queryParms)}`)
        },
        getFichas(queryParms) {
            return repository.get(`${baseUrl}/ficha?${urlUtil.serialize(queryParms)}`)
        },
        getFichaVacinacao(queryParms) {
            return repository.get(`${baseUrl}/ficha-vacinacao?${urlUtil.serialize(queryParms)}`)
        },
        destroy(id, queryParms) {
            return repository.delete(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`)
        },
    }
}